import React, { useState } from 'react'

import { Input } from 'app/components/ui/input'
import { Button } from 'app/components/ui/button'
import { Icons } from 'app/components/ui/icons';

// Brevo Form Configuration
const FORM_ACTION_URL = 'https://69d5cafd.sibforms.com/serve/MUIFAO4prUaOWNci7DltcMpo52Ud17yq-w6ioXwQSWlRCOZ4QCRsq1hk6g9zJe-MB64Na6obl2oXBGdwZY1D4jkCHSVxFK8UnTSJabkA-imv8eh26VgmVuijyB9cjXUlvH4EZ2GnrKD7w8d8lvdkKe7l4sq9zMrz-u-cR4i2QTRzDWdsLyANva224gUDF1q0Bqx-O2OS0GnqSORM';

// Error messages configuration
const REQUIRED_ERROR_MESSAGE = "This field cannot be left blank.";
const EMAIL_INVALID_MESSAGE = "The information provided is invalid. Please review the field format and try again.";
const GENERIC_ERROR_MESSAGE = "Your subscription could not be saved. Please try again.";

export const AlwaysConnected = () => {
  const [email, setEmail] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [message, setMessage] = useState({ text: '', type: '' })

  // Email validation function
  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Show message function
  const showMessage = (text: string, type: 'success' | 'error') => {
    setMessage({ text, type })
    if (type === 'success') {
      setTimeout(() => {
        setMessage({ text: '', type: '' })
      }, 5000)
    }
  }

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    const trimmedEmail = email.trim()
    
    if (!trimmedEmail) {
      showMessage(REQUIRED_ERROR_MESSAGE, 'error')
      return
    }
    
    if (!isValidEmail(trimmedEmail)) {
      showMessage(EMAIL_INVALID_MESSAGE, 'error')
      return
    }
    
    setIsSubmitting(true)
    setMessage({ text: '', type: '' })

    try {
      const formData = new FormData()
      formData.append('EMAIL', trimmedEmail)
      formData.append('email_address_check', '')
      formData.append('locale', 'en')
      
      // Submit to Brevo
      await fetch(FORM_ACTION_URL, {
        method: 'POST',
        body: formData,
        mode: 'no-cors' // Required for Brevo forms
      })
      
      // Since we're using no-cors, we can't read the response. Assume success if no error was thrown
      showMessage('Successfully subscribed! Thank you for joining us.', 'success')
      setEmail('')
      
    } catch (error) {
      console.error('Subscription error:', error)
      showMessage(GENERIC_ERROR_MESSAGE, 'error')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <section className="relative bg-[#A15A3B] flex flex-col items-center justify-center text-center px-3 sm:px-4 md:px-6 lg:px-8 pt-7 sm:pt-8 md:pt-9 lg:pt-[2.69rem] pb-10 sm:pb-12 md:pb-14 lg:pb-[3.97rem] overflow-hidden">
      <img src="/assets/reinforcement-1.svg" alt="Reinforcement" className="absolute left-0 bottom-0 w-1/3 sm:w-1/2 max-w-[32.3775rem]" />
      <img src="/assets/reinforcement-2.svg" alt="Reinforcement" className="absolute top-0 right-0 sm:right-6 lg:right-[2.12rem] w-1/3 sm:w-1/2 max-w-[21rem]" />
      <h2 className="font-mobile text-white text-[1.75rem] sm:text-3xl md:text-[2rem] lg:text-[2.125rem] font-normal leading-8 sm:leading-9 md:leading-10 lg:leading-[2.75rem]">
        VLE Mobile, Always Connected, Always Protected
      </h2>
      <p className="text-white text-sm sm:text-[0.925rem] lg:text-base font-medium leading-6 sm:leading-7 lg:leading-[2.1rem] tracking-[-0.03125rem] mb-3 sm:mb-4 lg:mb-[1.22rem]">
        Stay updated with our latest news and offers!
      </p>
      <form onSubmit={handleSubmit} className="relative w-full max-w-[25.9375rem]">
        <Input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="bg-white w-full h-14 sm:h-16 md:h-[4.25rem] lg:h-[4.5rem] py-2 sm:py-2.5 lg:py-3 pl-5 sm:pl-[1.375rem] lg:pl-6 pr-[7.5rem] sm:pr-32 lg:pr-36 border-none rounded-[3.8125rem] tex-[#0A0C0C] placeholder:text-[#0A0C0C99] text-sm sm:text-[0.825rem] lg:text-base font-medium leading-normal focus-visible:outline focus:outline-[#383E47]"
          placeholder="Enter your email"
          disabled={isSubmitting}
        />
        <Button
          type="submit"
          variant="blackBtn"
          disabled={isSubmitting}
          className="absolute top-1/2 -translate-y-1/2 right-2 sm:right-2.5 lg:right-3 w-fit h-10 sm:h-11 lg:h-12 px-5 sm:px-[1.375rem] lg:px-6 text-xs sm:text-[0.825rem] lg:text-sm leading-5 sm:leading-6 lg:leading-[1.7rem] disabled:opacity-100 disabled:bg-[#85857A]"
        >
          {isSubmitting ? 
            <div className="flex items-center gap-1 sm:gap-1.5">
              <Icons.Spinner className="w-3 h-3 sm:w-3.5 sm:h-3.5 animate-spin lg:w-4 lg:h-4" />
              <span>Subscribing...</span>
            </div>
            : 'Subscribe'}
        </Button>
      </form>
      {message.text && (
        <p className={`w-full max-w-[25.9375rem] pl-5 sm:pl-6 lg:pl-7 mt-1 sm:mt-1.5 text-left text-xs sm:text-[0.825rem] lg:text-sm font-medium ${
          message.type === 'success' 
            ? 'text-[#00E600]' 
            : 'text-[#FF7A66]'
          }`}
        >
          {message.text}
        </p>
      )}
    </section>
  )
}
